import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import { users } from "./services";
import Swal from "sweetalert2";

// PLUGINS
import "./plugins/VeeValidate";
import vuetify from "./plugins/Vuetify";
import "./plugins/SweetAlert";
import "./plugins/VueNotifycations";

// FILTROS
import filters from "./filters/index";
Vue.use(filters);

Vue.config.productionTip = false;

store.dispatch("auth/TRY_AUTO_LOGIN");

const publicVapidKey =
  "BHKUKxQMn5wmgGxIB1OOnZMckBbU78MgersfvRkaEnGckVwKpYPWAJLlnkHC6mEp0CadD5OjncPHnslpdl93Mqg";
function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

if ("serviceWorker" in navigator) {
  send().catch((err) => console.error(err));
}

async function send() {
  //register service worker
  const register = await navigator.serviceWorker.register("./worker.js", {
    scope: "/",
  });

  //register push
  const subscription = await register.pushManager.subscribe({
    userVisibleOnly: true,

    //public vapid key
    applicationServerKey: urlBase64ToUint8Array(publicVapidKey),
  });

  //Send push notification
  await fetch("https://ventas.flextd.com/api/push-notifications/subscribe", {
    method: "POST",
    body: JSON.stringify(subscription),
    headers: {
      "content-type": "application/json",
      Authorization: "Bearer " + localStorage.getItem("token"),
    },
  });
}

navigator.serviceWorker.addEventListener("message", (event) => {
  console.log(event);
});

new Vue({
  router,
  store,
  vuetify,
  created() {
    users.interceptors.response.use(
      function(response) {
        return response;
      },
      function(error) {
        if (401 === error.response.status) {
          Swal.fire({
            title: "Advertencia",
            text: "Su sesión ha expirado, por favor ingrese de nuevo",
            icon: "warning",
            confirmButtonColor: "#FACEA8",
            allowOutsideClick: false,
          }).then((result) => {
            if (result.value) {
              localStorage.clear();
              window.location = "/login";
            }
          });
        }
        return Promise.reject(error);
      }
    );
  },
  render: (h) => h(App),
}).$mount("#app");
